import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Droga} from "../../../domain/Droga";

@Injectable()
export class DrogaHttpService  extends AbstractHttpService<Droga>{
    url = '/api/droga';
}
